import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-installation-incidents',
  templateUrl: './installation-incidents.component.html',
  styleUrls: ['./installation-incidents.component.scss']
})
export class InstallationIncidentsComponent implements OnInit {

  @Input() installation: any;
  constructor() { }

  ngOnInit(): void {
  }

}
